export default "/images/vendor/@material-design-icons/svg/outlined/download_for_offline.svg?17a54471efe39faba8567883069bac06";